const GiftNote = function( container, config ){
    let nput,updateButton, toggleButton 
    const initialize = () => {
         toggleButton = container.querySelector( '[btn-toggle]');
         updateButton =  container.querySelector( '[btn-update]')
         input = container.querySelector( 'textarea')
         updateButton.removeEventListener('click', updateCart )
         toggleButton.removeEventListener('click', toggle )
         updateButton.addEventListener('click', updateCart )
         toggleButton.addEventListener('click', toggle )
     }
    const toggle = () => {
        if( container.classList.contains('active') ){
            container.classList.remove('active')
        }else{
            container.classList.add('active')
        }
    }
     updateCart = ( ) =>  {
        updateButton.innerText = 'Updating'
         fetch(`/cart/update.js`, {
             method: 'POST',
             credentials: 'same-origin',
             headers: {
                 'Content-Type': 'application/json',
                 'X-Requested-With': 'xmlhttprequest',
             },
             body: JSON.stringify({ "note" : input.value })
         })
         .then((response) => response.json())
         .then((json) => { 
            console.log( json )
            updateButton.innerText = 'Updated'
            window.setTimeout( () => {
                toggle();
            }, 200)
         })
     }
    initialize();


}

const InitGiftNotes = function(  options ){
    const init = function(){
        const  defaults = {
            selector: '[gift-note]'
        }
        config = { ...defaults, ...options }
        const containers = document.querySelectorAll( config.selector )
        if( containers ){
            containers.forEach( element => {
                GiftNote( element, config );
            });
        }
    };
    if( document.querySelector( 'html').dataset.brand == 'hawaiianhost'){        
        document.addEventListener('CartUpdated', (event) => {
             init();
        });
    }
    if( document.querySelector( 'html').dataset.brand == 'maunaloa'){        
        document.addEventListener('mx_shopify.cart.ajax.refreshed', (event) => {
             init();
        });
    }
    init();
}

export default InitGiftNotes